module.exports = __webpack_public_path__ + "img/du.ac64fb64.svg";